var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPublish = function SvgPublish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7C7C7C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13 7.5V18H1V2h6.545L9.5 3.5M15 2h-3.5M15 2l-.5 3.5M15 2 6.5 9.5"
  })));
};
export { SvgPublish as ReactComponent };
export default __webpack_public_path__ + "a1a56fa06d3dae05742961b3dafa5930.svg";